'use client';

import React from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string; // Image source (optional)
  text?: string; // Logo text (optional)
  iconName?: string; // Icon name when no image
  size?: number; // Size for icon/image
  className?: string; // Additional classes
  onClick?: () => void; // Click handler
}

function AppLogo({
  src = '/assets/images/MHP_-1771696153902.png',
  text,
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  return (
    <div
      className={`flex items-center gap-2 ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={onClick}
    >
      {/* Show image if src provided, otherwise show icon */}
      {src ? (
        <div className="relative">
          <AppImage 
            src={src} 
            alt="Logo" 
            width={size} 
            height={size} 
            className="flex-shrink-0 rounded-2xl" 
          />
          {/* White gradient fade at top-left corner */}
          <div 
            className="absolute top-0 left-0 w-full h-full rounded-2xl pointer-events-none"
            style={{
              background: 'radial-gradient(circle at top left, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.3) 25%, transparent 50%)'
            }}
          />
        </div>
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}

      {/* Show text if provided */}
      {text && <span className="text-xl font-bold">{text}</span>}
    </div>
  );
}

export default AppLogo;
